import { ReactNode, useEffect } from 'react';
import { useCurrentAuth } from '@/providers/CurrentAuthProvider';
import { useLocation, useNavigate } from 'react-router';
import { useCurrentUser } from '@/providers/CurrentUserProvider';
import { MessageBox, MessageBoxType } from '@/components/layout/MessageBox';
import { LoaderFullscreen } from '@/components/layout/Loader';
import { findRole, isCoachUser } from '@/services/CompanyService';
import { AuthRolesAndExperimentalFeatures } from '@/graphql/generated';

export const ConsultingCompanyAdministratorOnlyGuard = ({
  children,
}: {
  children: ReactNode;
}) => {
  const location = useLocation();
  const auth = useCurrentAuth();
  const { currentUser } = useCurrentUser();
  const navigate = useNavigate();

  const destination = encodeURIComponent(
    `${location.pathname}${location.search}`,
  );
  const loginUrl = `/login?destination=${destination}`;
  const role = currentUser ? findRole(currentUser) : undefined;

  useEffect(() => {
    if (auth === null) {
      navigate(loginUrl, { replace: true });
    }
  }, [auth, navigate, loginUrl]);

  if (!auth || !currentUser) {
    return (
      <div className="h-screen w-full">
        <LoaderFullscreen />
      </div>
    );
  }

  if (
    isCoachUser(currentUser) &&
    role === AuthRolesAndExperimentalFeatures.Administrator
  ) {
    return <>{children}</>;
  } else {
    return (
      <div className="h-screen w-full flex items-center justify-center">
        <div className="p-32 flex flex-col justify-center items-center gap-16 max-w-xl">
          <MessageBox type={MessageBoxType.Error}>
            Vous n'avez pas accès à cette page
          </MessageBox>
          <button className="primary" onClick={() => navigate('/')}>
            Retour à l'accueil
          </button>
        </div>
      </div>
    );
  }
};
